import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
const axes = [{
  title: 'Nivel de caos mental',
  desc: 'Evaluación de saturación y entorno.'
}, {
  title: 'Dependencia emocional',
  desc: 'Desconexión de la validación externa.'
}, {
  title: 'Control de pensamientos',
  desc: 'Herramientas contra la rumiación.'
}, {
  title: 'Responsabilidad radical',
  desc: 'Adiós a la victimización silenciosa.'
}, {
  title: 'Eliminación de estímulos tóxicos',
  desc: 'Desintoxicación digital y ambiental.'
}, {
  title: 'Rutina de estabilidad',
  desc: 'Pasos minimalistas para tus mañanas y noches.'
}];
export function TheSystem() {
  return <section className="py-24 md:py-32 px-6 bg-charcoal text-cream" data-id="element-187">
      <div className="max-w-6xl mx-auto" data-id="element-188">
        <FadeIn className="mb-16 md:mb-24" data-id="element-189">
          <div className="flex items-center gap-4 mb-6" data-id="element-190">
            <span className="text-3xl" data-id="element-191">🧠</span>
            <h2 className="text-sm tracking-widest uppercase text-terracotta font-semibold" data-id="element-192">
              El Sistema N°1 Para Desmantelar El Caos
            </h2>
          </div>
          <h3 className="text-3xl md:text-5xl leading-tight max-w-3xl mb-6" data-id="element-193">
            Estructura del Tomo 1 —{' '}
            <span className="italic text-cream/70" data-id="element-194">
              Nivel Inicial a Avanzado
            </span>{' '}
            — Todo Resuelto.
          </h3>
          <p className="text-xl text-cream/60 font-light max-w-2xl" data-id="element-195">
            Un método directo al grano que funciona desde hoy en tu casa, tu
            oficina o tu rutina diaria. Ejes temáticos incluidos:
          </p>
        </FadeIn>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12 md:gap-y-16" data-id="element-196">
          {axes.map((axis, i) => <StaggerItem key={i} className="relative" data-id="element-197">
              <div className="text-5xl font-serif text-white/5 absolute -top-6 -left-4 select-none pointer-events-none" data-id="element-198">
                0{i + 1}
              </div>
              <div className="relative z-10 pl-4 border-l border-terracotta/30" data-id="element-199">
                <h4 className="text-xl md:text-2xl font-serif mb-3" data-id="element-200">
                  {axis.title}
                </h4>
                <p className="text-cream/60 leading-relaxed font-light" data-id="element-201">
                  {axis.desc}
                </p>
              </div>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}